

import ClientHead from "@/components/main/core/ClientHead";
import VideoButton from "@/components/main/core/VideoButton";
import RedSection from "@/components/main/core/RedSection"

import BoxSection from "@/components/main/BoxSection";

import CheckBox from "@/components/main/core/CheckBox";

export default {

  head() {
    const title = 'Uncover Infidelity - Our Mission | iFindCheaters';
    const description = 'Learn about our mission to expose infidelity. iFindCheaters helps protect relationships by confidentially locating potential cheaters online. Explore how we can assist you today.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Mission to expose cheater, Catch a Cheater, Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, Find potential cheaters'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/our-missions/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Our mission ᐈ iFindCheaters",
            }],
          }
        }
      ]
    };
  },

  name: "our-missions",
  layout: 'clientLayout',

  components: {VideoButton, RedSection, CheckBox, BoxSection, ClientHead, },



}

